import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

function SecurityScanner({ width = 24, height = 24, color = "primary" }) {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M2 14.25a.75.75 0 01.75.75c0 1.92.003 3.001.135 3.76.118.673.33 1.051.817 1.538.423.423 1.003.677 2.009.812 1.028.138 2.382.14 4.289.14a.75.75 0 010 1.5h-.056c-1.838 0-3.294 0-4.433-.153-1.172-.158-2.121-.49-2.87-1.238-.684-.685-1.058-1.336-1.233-2.341-.158-.904-.158-2.123-.158-3.922V15a.75.75 0 01.75-.75zM22 14.25a.75.75 0 01.75.75v.096c0 1.8 0 3.018-.158 3.922-.175 1.005-.549 1.656-1.233 2.34-.749.75-1.698 1.081-2.87 1.239-1.14.153-2.595.153-4.433.153H14a.75.75 0 010-1.5c1.907 0 3.262-.002 4.29-.14 1.005-.135 1.585-.389 2.008-.812.487-.487.7-.865.817-1.538.132-.759.135-1.84.135-3.76a.75.75 0 01.75-.75zM18.29 2.89c-1.028-.138-2.383-.14-4.29-.14a.75.75 0 010-1.5h.056c1.838 0 3.294 0 4.433.153 1.172.158 2.121.49 2.87 1.238.684.685 1.058 1.336 1.233 2.341.158.904.158 2.122.158 3.922V9a.75.75 0 01-1.5 0c0-1.92-.003-3.001-.135-3.76-.118-.673-.33-1.051-.817-1.538-.423-.423-1.003-.677-2.009-.812zM9.944 1.25H10a.75.75 0 010 1.5c-1.907 0-3.261.002-4.29.14-1.005.135-1.585.389-2.008.812-.487.487-.7.865-.817 1.538-.132.759-.135 1.84-.135 3.76a.75.75 0 11-1.5 0v-.096c0-1.8 0-3.018.158-3.922.175-1.005.549-1.656 1.233-2.34.749-.75 1.698-1.081 2.87-1.239 1.14-.153 2.595-.153 4.433-.153zM1.25 12a.75.75 0 01.75-.75h20a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default SecurityScanner;
